import React from "react";

function UIBody({ children, className = {}, style = {} }) {
  return (
    <div
      style={{
        minHeight: 700,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#faf9f8",
        flex: 1,
        gap: 10,
        ...style,
      }}
      className={className}
    >
      {children}
    </div>
  );
}

export default UIBody;
